import L from 'leaflet';
import chroma from 'chroma-js';
import defaultIcon from '../../assets/images/green_marker.svg';
import redIcon from '../../assets/images/red_marker.svg';
import goldIcon from '../../assets/images/gold_marker.svg';
import silverIcon from '../../assets/images/silver_marker.svg';
import bronzeIcon from '../../assets/images/bronze_marker.svg';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import './drawing.css';

let DefaultIcon = L.icon({
  iconUrl: defaultIcon,
  iconSize: [40, 41],
  iconAnchor: [32, 40],
  shadowUrl: iconShadow
});

let RedIcon = L.icon({
  iconUrl: redIcon,
  iconSize: [40, 41],
  iconAnchor: [32, 40],
  shadowUrl: iconShadow
});

let GoldIcon = L.icon({
  iconUrl: goldIcon,
  iconSize: [40, 41],
  iconAnchor: [32, 40],
  shadowUrl: iconShadow
});

let SilverIcon = L.icon({
  iconUrl: silverIcon,
  iconSize: [40, 41],
  iconAnchor: [32, 40],
  shadowUrl: iconShadow
});

let BronzeIcon = L.icon({
  iconUrl: bronzeIcon,
  iconSize: [40, 41],
  iconAnchor: [32, 40],
  shadowUrl: iconShadow
});

const scale = chroma.scale([
  '#a50026',
  '#d73027',
  '#f46d43',
  '#fdae61',
  '#fee08b',
  '#d9ef8b',
  '#a6d96a',
  '#66bd63',
  '#1a9850',
  '#006837'
]);

export const getColor = d => scale(d || 0).hex();

export const drawChoropleth = (map, geoJson, regionAction) => {
  const style = feature => ({
    fillColor: getColor(feature.properties.density),
    weight: 2,
    opacity: 1,
    color: 'white',
    dashArray: '3',
    fillOpacity: 0.75
  });

  const highLightFeature = e => {
    const layer = e.target;
    layer.setStyle({
      weight: 5,
      color: 'white',
      dashArray: '',
      fillOpacity: 0.7
    });
  };

  const layerAction = e => {
    if (regionAction) regionAction(e);
  };

  const resetFeature = e => {
    chorolpleth.resetStyle(e.target);
  };

  const onEachFeature = (feature, layer) => {
    //layer.bindPopup(feature.properties.name).openPopup({});
    layer.on({
      mouseover: highLightFeature,
      mouseout: resetFeature,
      click: layerAction
    });
  };

  const chorolpleth = L.geoJson(geoJson, {
    style: style,
    onEachFeature: onEachFeature
  });

  chorolpleth.addTo(map);
  map.fitBounds(chorolpleth.getBounds());
  return chorolpleth;
};

export const drawLegend = (map, legends) => {
  const legend = L.control({ position: 'bottomright' });
  legend.onAdd = function(map) {
    var div = L.DomUtil.create('div', 'info legend');
    div.innerHTML += legends;
    return div;
  };
  legend.addTo(map);
  return legend;
};

export const drawSummary = (map, summaryInfo) => {
  const summary = L.control({ position: 'topleft' });
  summary.onAdd = function(map) {
    var div = L.DomUtil.create('div', 'summary');
    div.innerHTML += summaryInfo;
    return div;
  };
  summary.addTo(map);
  return summary;
};

export const drawRegionLabel = (map, geoJson) => {
  const eachPoint = (feature, latlng) => {
    return new L.circleMarker(latlng, { radius: 1 })
      .bindTooltip(`${feature.properties.density}`, {
        permanent: true,
        direction: 'top'
      })
      .openTooltip();
  };
  const geo_json = L.geoJson(geoJson, { pointToLayer: eachPoint });
  geo_json.addTo(map);
  return geo_json;
};

export const drawBoundary = (map, geoJson) => {
  const geo_json = L.geoJson(geoJson);
  geo_json.addTo(map);
  map.fitBounds(geo_json.getBounds());
  return geo_json;
};

export const drawMarkers = (map, markers) => {
  const markers_obj = markers.map(marker => {
    var icon = DefaultIcon;
    switch (marker.color) {
      case 'red':
        icon = RedIcon;
        break;
      case 'gold':
        icon = GoldIcon;
        break;
      case 'silver':
        icon = SilverIcon;
        break;
      case 'bronze':
        icon = BronzeIcon;
        break;
      default:
        icon = DefaultIcon;
        break;
    }
    return L.marker(marker.location, {
      icon: icon
    })
      .bindTooltip(marker.tooltip)
      .openTooltip();
  });
  const markers_layer = L.layerGroup(markers_obj);
  markers_layer.addTo(map);
  return markers_layer;
};
